import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { HOTEL_ID } from '../constants';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { QRCodeSVG } from 'qrcode.react';
import { Primary } from '../theme/colors';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { selectHotelConfig } from 'store/slice/hotelConfigSlice';
import { selectBookingData } from 'store/slice/bookingSlice';
import { selectCurrentLanguage } from 'store/slice/appConfigSlice';
import useGetSpecialLayoutValue from 'hooks/useGetLayoutConfig';
const { REACT_APP_API_URL } = process.env;

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.light,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  errorMessage: {
    color: theme.palette.error.main,
  },
  qrcode: {
    marginBlock: theme.spacing(8),
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}));

export const Confirm = () => {
  const classes = useStyles();
  const hotelId = useSelector(selectHotelConfig).hotelId;
  const url = REACT_APP_API_URL + 'notifications/prearrival-successful';
  const settings = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      authorization: 'Bearer ' + localStorage.getItem('token'),
    },
    timeout: 6000000,
  };
  // console.log(localStorage);
  const bookingData = useSelector(selectBookingData);
  const currentLanguage = useSelector(selectCurrentLanguage);
  let confirmationNumber = bookingData.confirmationNumber;
  let email = bookingData.email;
  let lang = currentLanguage || 'en';

  const hasCustomizedConfirmReminder = useGetSpecialLayoutValue(
    'hasCustomizedConfirmReminder'
  );

  useEffect(() => {
    if (confirmationNumber !== '') {
      try {
        const resData = {
          bookingNumber: confirmationNumber,
          email: email,
          language: lang,
        };
        const response = axios.post(url, resData, settings);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          console.log(error);
        }
      }
    }
  }, []);

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper} style={{ marginLeft: '1rem' }}>
        <h4 style={{ color: Primary, marginBottom: '60px' }}>
          <FormattedMessage id="confirm.title" />
        </h4>
        {hotelId === HOTEL_ID.PLAZA ? (
          <>
            <h5 style={{ color: '#808080' }}>
              <FormattedMessage id="confirm.deposit" />
            </h5>
            {confirmationNumber !== '' && (
              <>
                <Grid
                  item
                  xs={12}
                  className={classes.qrcode}
                  style={{ marginBottom: '30px' }}
                >
                  <QRCodeSVG
                    value={confirmationNumber}
                    level={'H'}
                    size={300}
                  />
                </Grid>
                <h5 style={{ color: '#808080' }}>
                  <FormattedMessage id="confirm.reminder" />
                </h5>
                <h5 style={{ color: '#808080' }}>
                  <FormattedMessage id="confirm.reminder2" />
                </h5>
                <h5 style={{ color: '#808080' }}>
                  <FormattedMessage id="confirm.thankyou" />
                </h5>
              </>
            )}
          </>
        ) : (
          <>
            <h5 style={{ color: '#808080' }}>
              <FormattedMessage
                id={`confirm.reminder${
                  hasCustomizedConfirmReminder ? `.${hotelId}` : ''
                }`}
              />
            </h5>
            <>
              {confirmationNumber !== '' && (
                <>
                  <h5 style={{ color: '#808080' }}>
                    <FormattedMessage
                      id={`confirm.reminder2${
                        hasCustomizedConfirmReminder ? `.${hotelId}` : ''
                      }`}
                    />
                  </h5>
                  <h5 style={{ color: '#808080' }}>
                    <FormattedMessage id="confirm.thankyou" />
                  </h5>

                  <Grid item xs={12} className={classes.qrcode}>
                    <QRCodeSVG
                      value={confirmationNumber}
                      level={'H'}
                      size={300}
                    />
                  </Grid>
                </>
              )}
            </>
          </>
        )}
      </div>
    </Container>
  );
};
